"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdString = getIdString;
exports.indexByIdString = exports.indexById = exports.getId = void 0;

var _always = _interopRequireDefault(require("transmute/always"));

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _protocol = _interopRequireDefault(require("transmute/protocol"));

var _toString = _interopRequireDefault(require("transmute/toString"));

var noId = (0, _always.default)(undefined);
/**
 * Returns the id of `subject`.
 *
 * @param  {TYPE} subject
 * @return {any}
 */

var getId = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'Identifiable#getId'
});
exports.getId = getId;
getId.implement(null, noId);
getId.implement(undefined, noId);
/**
 * Returns the string id of `subject`.
 *
 * @param  {TYPE} subject
 * @return {string}
 */

function getIdString(subject) {
  var id = getId(subject);
  return id == null ? id : (0, _toString.default)(id);
}
/**
 * Returns an OrderedMap of subjects by id.
 *
 * @param  {Iterable<TYPE>} subjects
 * @return {OrderedMap<any, TYPE>}
 */


var indexById = (0, _indexBy.default)(getId);
/**
 * Returns an OrderedMap of subjects by string id.
 *
 * @param  {Iterable<TYPE>} subjects
 * @return {OrderedMap<string, TYPE>}
 */

exports.indexById = indexById;
var indexByIdString = (0, _indexBy.default)(getIdString);
exports.indexByIdString = indexByIdString;